import Cookies from 'js-cookie';

export function getGBSessionId(): string {
  const cookieName = 'fc-gb-session-id';
  const sessionId = Cookies.get(cookieName);

  return sessionId;
}

export async function waitForSessionId(getSessionId: () => string | undefined, maxTries = 5, delayMs = 200): Promise<string | undefined> {
  let tries = 0;
  while (tries < maxTries) {
    const sessionId = getSessionId();
    if (sessionId) return sessionId;
    tries += 1;
    // eslint-disable-next-line no-await-in-loop
    await new Promise(resolve => setTimeout(resolve, delayMs));
  }
  return undefined;
}

function readCookie(name: string) {
  // Match start-of-string or semicolon + optional space, then name=value until next ; or end
  const m = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : null;
}

export function getFbc() {
  return readCookie('_fbc');
}

export function getFbp() {
  return readCookie('_fbp');
}

export function computeSessionData() {
  const sessionData: {
    url?: string;
    userAgent?: string;
    fbc?: string | null;
    fbp?: string | null;
  } = {};
  try {
    sessionData.url = window.location.href;
    sessionData.userAgent = navigator.userAgent;
    sessionData.fbc = getFbc();
    sessionData.fbp = getFbp();
  } catch (e) {
    console.log(e);
  }
  return sessionData;
}
